import { TFunction } from "i18next";
import { Link } from "react-router-dom";

import { Button, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";

import { ProductType } from "@type/inventory/procurements";
import { NameType } from "@type/inventory/name";

export const ProcurementDetailsTableColumn = (
  t: TFunction<"translation", undefined>,
  onAddTagOpen: (data: ProductType) => void,
  handleAddToStock: (data: ProductType) => void,
  isLoading: boolean,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "nameBn",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.NAME"),
      render: (_: string, row: any) => {
        const name = language === "bn" ? row?.name?.nameBn : row?.name?.nameEn;
        return <Text color="subtitle1">{name ? name : "..."}</Text>;
      },
    },
    {
      id: 2,
      key: "name",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.CATEGORY"),
      render: (name: NameType) => {
        return (
          <Text color="subtitle1">
            {name?.group?.category?.name ? name?.group?.category?.name : "..."}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "name",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.GROUP"),
      render: (name: NameType) => (
        <Text color="subtitle1">
          {name?.group?.name ? name?.group?.name : "..."}
        </Text>
      ),
    },
    {
      id: 4,
      key: "type",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.TYPE"),
      render: (type: number) => (
        <Text color="subtitle1">
          {type ? (type === 1 ? "Asset" : "Item") : "..."}
        </Text>
      ),
    },

    {
      id: 5,
      key: "amount",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.UNIT"),
      render: (amount: number) => (
        <Text color="subtitle1">{amount ? amount : "..."}</Text>
      ),
    },
    {
      id: 6,
      key: "unitPrice",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.UNIT_PRICE"),
      render: (unitPrice: number) => (
        <Text color="subtitle1">{unitPrice ? unitPrice : "..."}</Text>
      ),
    },
    {
      id: 7,
      key: "unitPrice",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.TOTAL_PRICE"),
      render: (_: string, row: any) => {
        const total = row?.unitPrice * row?.amount;
        return <Text color="subtitle1">{total ? total : "..."}</Text>;
      },
    },
    {
      id: 8,
      key: "warrantyStartDate",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.WARRANTY_START_&_END"),
      render: (_: string, row: any) => (
        <div className="d-flex gap-2">
          {row?.warrantyStartDate && row?.warrantyEndDate ? (
            <>
              <Text color="subtitle2" component="p">
                {row?.warrantyStartDate}
              </Text>
              ~
              <Text color="warning" component="p">
                {row?.warrantyEndDate}
              </Text>
            </>
          ) : (
            <Text color="subtitle1">{"..."}</Text>
          )}
        </div>
      ),
    },
    {
      id: 9,
      key: "lotNo",
      name: t("PROCUREMENTS_DETAILS.TABLE.COLUMN.LOT_NO"),
      render: (lotNo: string) => (
        <Text color="subtitle1">{lotNo ? lotNo : "..."}</Text>
      ),
    },
    // {
    //   id: 10,
    //   key: "status",
    //   render: (_: any, row: any) => {
    //     return (
    //       <div className="d-flex justify-content-end">
    //         {row?.lotNo && (
    //           <>
    //             {!row?.tagStatus ? (
    //               <Button
    //                 fill="outline"
    //                 type="primary"
    //                 size="xs"
    //                 onClick={() => onAddTagOpen(row)}
    //               >
    //                 {row?.type === 1
    //                   ? t("PROCUREMENTS_DETAILS.TABLE.TAG_ASSET_BUTTON")
    //                   : t("PROCUREMENTS_DETAILS.TABLE.TAG_ITEM_BUTTON")}
    //               </Button>
    //             ) : (
    //               <Button
    //                 disabled={row?.stockStatus}
    //                 fill="fill"
    //                 type="primary"
    //                 size="xs"
    //                 onClick={() => handleAddToStock(row)}
    //                 loading={isLoading}
    //               >
    //                 {t("PROCUREMENTS_DETAILS.TABLE.ADD_TO_STOCK_BUTTON")}
    //               </Button>
    //             )}
    //           </>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      id: 11,
      key: "status",
      render: (_: any, row: any) => {
        return (
          <div className="d-flex justify-content-end">
            <Link to={`${row.id}`}>
              <Button fill="outline" type="light" size="xs" className="me-5">
                {t("PROCUREMENTS_DETAILS.TABLE.VIEW")}
              </Button>
            </Link>
          </div>
        );
      },
    },
  ];
};
